






















































































import {Component} from 'vue-property-decorator';
import {Getter} from "vuex-class";
import ScrollButton from "@/components/ScrollButton.vue";
import BaseItemsPage from "@/pages/Pages/BaseItemsPage";
import { AddressBookItem } from '@/store/addressbooks/types'
import {DateTime} from "luxon";
import AddressBooksFilter from "@/components/AddressBooks/AddressBooksFilter.vue";

@Component({components: {AddressBooksFilter, ScrollButton},filters: {
  date(value: string) {
    if (!value) return;
    return DateTime.fromISO(value).toFormat('dd.LL.yyyy HH:mm:ss')
  }
}})
export default class AddressBooks extends BaseItemsPage<AddressBookItem>{
  @Getter("addressBooks") addressbooksResponse: any;
  private is_show_filter = false;
  currentSort = "name";
  currentSortOrder = "desc";
  tableFields = ['id', 'name', 'create_date', 'contacts', 'comment'];

  getData(): any {
    return this.addressbooksResponse;
  }
}
